<template>
  <div :class="`container ${plat}`">
    <div class="page page-01">
      <div class="hm-head">
        <div class="hm-logo">
          <img :style="psy" src="../../assets/img_logo01_pc.png" alt="">
          <!-- <img :style="psy" src="../../assets/img_xiaozhao_pc.png" alt=""> -->
          <img :style="msy" src="../../assets/img_logo01_m.png" alt="">
          <!-- <img :style="msy" src="../../assets/img_xiaozhao_m.png" alt=""> -->
        </div>
        <ul :style="psy" class="hm-options">
          <li :class="[{ 'active': $store.state.activeTopTab === 0 }]" @click="changeTab(0)">首页</li>
          <li :class="[{ 'active': $store.state.activeTopTab === 4 }]" @click="changeTab(4)">社招岗位</li>
          <li :class="[{ 'active': $store.state.activeTopTab === 1 }]" @click="changeTab(1)">校招岗位</li>
          <!-- <li :class="[{ 'active': $store.state.activeTopTab === 3 }]" @click="changeTab(3)">招聘动态</li> -->
          <li :class="[{ 'active': $store.state.activeTopTab === 2 }]" @click="changeTab(2)">关于盈趣</li>
        </ul>
        <div :style="msy" class="hm-more" @click="expandMore"><img src="../../assets/icon_menu01.png" alt=""></div>
      </div>
      <div class="hm-content" ref="hmContent">
        <div class="hm-underCnt">
          <img class="banner" :style="psy" src="../../assets/banner_pc.png" alt="">
          <img class="banner" :style="msy" src="../../assets/banner_m.png" alt="">
        </div>
        <div class="hm-aboveCnt" :style="psy">
          <img class="img2" ref="hmImg_21" src="../../assets/img_slogan_pc.png" alt="">
          <div style="display:flex;margin: -40px 0 150px 0;">
            <div style="margin-right: 10px;" class="deliver" @click.stop="scrollTab(1)">社招投递</div>
            <div style="margin-left: 10px;" class="deliver" @click.stop="scrollTab(2)">校招投递</div>
          </div>
          <img class="img3" ref="hmImg_3" src="../../assets/img_jiantou.png" alt="">
        </div>
        <div class="hm-aboveCnt" :style="msy">
          <img class="img2" ref="hmImg_22" src="../../assets/img_slogan_m.png" alt="">
          <div style="margin: -40px 0px 0px;">
            <div class="deliver" @click.stop="scrollTab(1)">社招投递</div>
            <div style="margin-top:20px" class="deliver" @click.stop="scrollTab(2)">校招投递</div>
          </div>
          <img class="img3" ref="hmImg_3" src="../../assets/img_jiantou.png" alt="">
        </div>
      </div>
      <div :class="['fix-head', { 'hide': hideHD === true }]" @click="closeMore">
        <div class="hm-logo">
          <span>
            <img src="../../assets/img_logo21_m.png" alt="">
            <!-- <img src="../../assets/img_xiaozhao1_m.png" alt=""> -->
          </span>
          <span class="hm-close">
            <img src="../../assets/icon_off_m.png" alt="">
          </span>
        </div>
        <ul class="hm-options">
          <li :class="[{ 'active': $store.state.activeTopTab === 0 }]" @click.stop="changeTab(0)">首页</li>
          <li :class="[{ 'active': $store.state.activeTopTab === 4 }]" @click.stop="changeTab(4)">社招岗位</li>
          <li :class="[{ 'active': $store.state.activeTopTab === 1 }]" @click.stop="changeTab(1)">校招岗位</li>
          <li :class="[{ 'active': $store.state.activeTopTab === 2 }]" @click.stop="changeTab(2)">关于盈趣</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      hideHD: true,
      plat: `plat-${this.$store.state.plat}`,
      psy: { display: this.$store.state.plat === 'Web' ? '' : 'none' },
      msy: { display: this.$store.state.plat === 'Mobile' ? '' : 'none' },
    }
  },
  mounted() {
    if (this.$route.query.tab) {
      this.changeTab(parseInt(this.$route.query.tab, 10))
    }
    if (this.$store.state.plat === "Mobile") {
      // console.log("我被执行啦~~")
      this.$store.state.activeTopTab = 0
    }
    // console.log('初始', this.$store.state.activeTopTab);
    setTimeout(() => {
      let cntHeight = this.$refs.hmContent.getBoundingClientRect().height;
      if (this.$store.state.plat === 'Web') {
        this.$refs.hmImg_21.style.margin = `${cntHeight * 0.01}px 0 ${cntHeight * 0.15}px 0`
      } else {
        this.$refs.hmImg_22.style.margin = `${cntHeight * 0.05}px 0 ${cntHeight * 0.25}px 0`
      }
      this.$refs.hmImg_3.style.margin = `${cntHeight * 0.12}px 0 ${cntHeight * 0.05}px 0`
      // console.log('高度。。',cntHeight)
    }, 100)
  },
  methods: {
    changeTab(index) {
      console.log("index:", index)
      this.$store.state.activeTopTab = index
      
      // console.log('tab-head', index)
      if (this.$store.state.plat === "Mobile") {
        if (index == 1) {//校招
          this.$store.state.activeMobile = 2
          this.$store.state.activeTopTab = 1
        } else if (index == 4) {//社招
          this.$store.state.activeMobile = 1
          this.$store.state.activeTopTab = 4
        }
        this.hideHD = true;
      }
      // 校招岗位(web)
      if (index === 1) {
        if (this.$store.state.plat === 'Web') {
          this.$router.push("schoolPost?tab=1&type=2");
          return;
        }
      }
      if (index === 4) {
        if (this.$store.state.plat === 'Web') {
          this.$router.push("schoolPosts?tab=4&type=1");
          return;
        }
      }
      // 关于盈趣
      if (index === 2) {
        if (this.$route.fullPath.indexOf('aboutYq') === -1) {
          this.$router.push("aboutYq?tab=2");
        }
        return;
      }
      // 首页 / 招聘动态（web）/ 校招岗位（mobile）
      if (this.$route.fullPath.indexOf('home') === -1) {
        this.$router.push("home?tab=" + index);
      }
      if ((index === 1 || index === 4) && document.querySelector('.page-02')) {
        let offTop = document.querySelector('.page-02').offsetTop
        console.log("offTop:", offTop)
        document.getElementById('main-can-scroll').scrollTop = offTop - Math.floor(this.$store.state.plat === 'Web' ? window.innerHeight * 0.07 : 0)
      }
    },
    closeMore() {
      this.hideHD = true
    },
    expandMore() {
      this.hideHD = false
    },
    scrollTab(val) {
      if (this.$store.state.plat === 'Web') {
        val == 1 ? this.$router.push('schoolPosts?tab=4&type=' + val) : this.$router.push('schoolPost?tab=1&type=' + val)
        return false
      }
      if (val == 1) {//社招
        this.$store.state.activeMobile = 1
        this.$store.state.activeTopTab = 4
      } else if (val == 2) {//校招
        this.$store.state.activeMobile = 2
        this.$store.state.activeTopTab = 1
      }
      let offTop = document.querySelector('.page-02').offsetTop
      document.getElementById('main-can-scroll').scrollTop = offTop
    }
  }
}
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import "../../components/common/common.less";

.container {
  height: 100%;

  &.plat-Mobile {
    .page-01 {
      .hm-head {
        padding: 0 7%;
      }

      .hm-content {
        .hm-aboveCnt {
          img.img1 {
            width: 60%;
          }

          img.img2 {
            width: 85%;
          }

          img.img3 {
            width: 6%;
          }
        }
      }
    }
  }

  .page-01 {
    position: relative;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.3);

    .fix-head {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      width: 100%;
      height: 100%;
      z-index: 100;
      background: rgba(0, 0, 0, 0.3);

      &.hide {
        display: none;
      }

      .hm-logo {
        background: #fff;
        width: 100%;
        height: 7vh;
        display: flex;
        align-items: center;
        justify-content: space-between;
        box-sizing: border-box;
        padding: 0 7%;

        span {
          height: 100%;
          display: flex;
          align-items: center;
        }

        img {
          height: 50%;
          margin-right: 10px;
        }

        .hm-close {
          width: 18px;

          &>img {
            width: 100%;
            height: unset;
          }
        }
      }

      .hm-options {
        width: 100%;
        flex-direction: column;
        padding: 10px 0;
        background: #fff;

        li {
          width: 100%;
          margin-right: 0;
          padding-left: 12px;
          box-sizing: border-box;
          line-height: 50px;

          // font-weight: bold;
          &.active {
            color: #FF5F00;
          }
        }
      }
    }

    .hm-head {
      width: 100%;
      height: 7vh;
      background: rgba(0, 0, 0, 0.3);
      color: #fff;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 18%;
      box-sizing: border-box;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      z-index: 20;

      .hm-logo {
        height: 100%;
        display: flex;
        align-items: center;

        img {
          height: 50%;
          margin-right: 10px;
        }
      }

      .hm-more {
        height: 100%;
        display: flex;
        align-items: center;

        img {
          height: 40%;
        }
      }

      .hm-options {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 16px;

        li {
          cursor: pointer;
          margin-right: 72px;
          line-height: 30px;

          &.active {
            font-weight: bold;
            // transform: scale(1.1);
            border-bottom: 2px solid #fff;
          }

          &:last-child {
            margin-right: 0;
          }
        }
      }
    }

    .hm-content {
      width: 100%;
      height: 100%;
      position: relative;

      .hm-underCnt {
        width: 100%;
        height: 100%;

        img.banner {
          width: 100%;
          height: 100%;
          object-fit: fill;
        }
      }

      .hm-aboveCnt {
        width: 100%;
        height: max-content;
        position: absolute;
        bottom: 0;
        right: 0;
        left: 0;
        z-index: 10;
        background: rgba(255, 255, 255, 0);
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        img.img1 {
          width: 30%;
          max-width: 60%;
        }

        img.img2 {
          width: 55%;
          max-width: 85%;
          margin: 2rem 0 4rem 0;
        }

        img.img3 {
          width: 36px;
          max-width: 6%;
          margin: 4rem 0 2rem 0;
          cursor: pointer;
        }

        .deliver {
          padding: 12px 36px;
          text-align: center;
          color: #FF5F00;
          background: rgba(255, 255, 255, 0.9);
          border-radius: 5px;
          font-size: 16px;
          font-weight: bold;
          letter-spacing: 1px;
          .cmSelectNone();
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/cap-page-01/cap-page-01.vue